import Box from '@mui/material/Box';
import {
    Button, CircularProgress, FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import { TempRegisterUser, TempRegisterUserActionForm } from '../../../app/models/admin';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { collectionFormStyles } from '../../basicUser/basicUserForms/collectionFormStyles';
import ValidationErrors from '../../errors/ValidationErrors';
import FormValues from '../../../app/common/formValue/FormValues';
import { tempRegisterUserSchema } from '../../../app/common/formValidations/validationSchemes';
import { toast } from 'react-toastify';

interface Props {
    tempUser: TempRegisterUser;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        // bgcolor: 'background.paper',
        bgcolor: '#DAE5F1',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
        // height: isMobile ? 650 : 800,
    })
};

const AdminTempUserActionModal = ({ tempUser }: Props) => {

    const { modalStore, userStore, adminStore } = useStore();
    const { closeModal } = modalStore;
    const { user } = userStore;
    const { verifyTempRegsiterUser, verifyTempRegisterUserLoading } = adminStore;
    const matches = useMediaQuery('(min-width:900px)');

    if (!tempUser)
        return null;

    const initialValues: TempRegisterUserActionForm = {
        email: tempUser.email,
        roles: [],
        actionName: 'approved',
        error: null
    }
    return (
        <Box sx={style(matches)}>
            <Typography variant='h4' textAlign='center'>Pending Signups</Typography>
            <Formik
                initialValues={initialValues}
                validationSchema={tempRegisterUserSchema}
                onSubmit={(values: TempRegisterUserActionForm, { setErrors }) => {
                    verifyTempRegsiterUser(values)
                        .then(() => closeModal())
                        .catch(error => setErrors({ error }))
                }}
            >
                {({ values,
                    handleChange,
                    handleBlur,
                    errors
                }) => {
                    return (
                        <Form autoComplete="off">
                            <Box sx={collectionFormStyles.partnerFormControls}>
                                <Stack direction='column' spacing={2} m={2} alignItems='center'>
                                    <FormControl sx={{ width: 300 }}>
                                        <Field
                                            type="text"
                                            label="Email"
                                            component={TextField}
                                            id="email"
                                            name="email"
                                            placeholder="Email"
                                            fullWidth
                                            margin="normal"
                                            disabled
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.email}
                                            variant="outlined"
                                        />
                                        <ErrorMessage name="email" component="div" className='errorTextBlack' />
                                    </FormControl>
                                    {/* <FormControl sx={{ width: 300 }}>
                                        <InputLabel id="roles">Roles</InputLabel>
                                        <Select
                                            labelId="roles"
                                            id="roles"
                                            name="roles"
                                            multiple
                                            value={values.roles}
                                            label="Roles"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{ minWidth: 180 }}
                                            MenuProps={MenuProps}
                                        >
                                            {user?.partnerRolePriorities.map((role) => (
                                                <MenuItem value={role.partnerRole} key={role.id}>{role.partnerRole}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl> */}
                                    <RadioGroup
                                        row
                                        aria-labelledby="temp-partner-approval"
                                        name="actionName"
                                        defaultValue="approved"
                                    >
                                        <Box component={'div'} sx={{ m: '10px auto' }}>
                                            <FormControlLabel value="approved" control={<Radio onChange={handleChange} />} label="Approved" />
                                            <FormControlLabel value="blocked" control={<Radio onChange={handleChange} />} label="Block" />
                                        </Box>
                                    </RadioGroup>
                                    <ErrorMessage
                                        name='error' render={() =>
                                            <ValidationErrors errors={errors.error} />
                                        }
                                    />
                                </Stack>
                            </Box>
                            <Stack
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                                pt={5}
                            >
                                {verifyTempRegisterUserLoading ? <CircularProgress size='1.2rem' /> :
                                    <Button size="medium" variant="contained" name='create' id='create' type='submit' >Create</Button>
                                }
                            </Stack>
                        </Form>

                    );
                }}

            </Formik>
        </Box>
    )
}
export default observer(AdminTempUserActionModal);